// ImbCardStack.tsx
// Copyright (c) 2020 Neomantra Corp

import React, { useState, useEffect, useRef, useContext } from 'react'
import ImbTickerCard from './TickerCard'
import { Responsive, WidthProvider } from 'react-grid-layout'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import { defaults } from 'react-chartjs-2'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/rootReducer'

const layoutLg = [
        { i: '0', x: 0, y: 0, w: 4, h: 3.5 },
        { i: '1', x: 4, y: 0, w: 4, h: 3.5 },
        { i: '2', x: 8, y: 0, w: 4, h: 3.5 },
        { i: '3', x: 0, y: 3.5, w: 4, h: 3.5 },
        { i: '4', x: 4, y: 3.5, w: 4, h: 3.5 },
        { i: '5', x: 8, y: 3.5, w: 4, h: 3.5 },
        { i: '6', x: 0, y: 7, w: 4, h: 3.5 },
        { i: '7', x: 4, y: 7, w: 4, h: 3.5 },
        { i: '8', x: 8, y: 7, w: 4, h: 3.5 },
        { i: '9', x: 0, y: 10.5, w: 4, h: 3.5 },
        { i: '10', x: 4, y: 10.5, w: 4, h: 3.5 },
        { i: '11', x: 8, y: 10.5, w: 4, h: 3.5 },
    ],
    layoutMd = [
        { i: '0', x: 0, y: 0, w: 6, h: 3.5 },
        { i: '1', x: 6, y: 0, w: 6, h: 3.5 },
        { i: '2', x: 0, y: 3.5, w: 6, h: 3.5 },
        { i: '3', x: 6, y: 3.5, w: 6, h: 3.5 },
        { i: '4', x: 0, y: 7, w: 6, h: 3.5 },
        { i: '5', x: 6, y: 7, w: 6, h: 3.5 },
        { i: '6', x: 0, y: 10.5, w: 6, h: 3.5 },
        { i: '7', x: 6, y: 10.5, w: 6, h: 3.5 },
        { i: '8', x: 0, y: 14, w: 6, h: 3.5 },
        { i: '9', x: 6, y: 14, w: 6, h: 3.5 },
        { i: '10', x: 0, y: 17.5, w: 6, h: 3.5 },
        { i: '11', x: 6, y: 17.5, w: 6, h: 3.5 },
    ],
    layoutSm = [
        { i: '0', x: 0, y: 0, w: 6, h: 3 },
        { i: '1', x: 0, y: 0, w: 6, h: 3 },
        { i: '2', x: 0, y: 3, w: 6, h: 3 },
        { i: '3', x: 0, y: 3, w: 6, h: 3 },
        { i: '4', x: 0, y: 6, w: 6, h: 3 },
        { i: '5', x: 0, y: 6, w: 6, h: 3 },
        { i: '6', x: 0, y: 9, w: 6, h: 3 },
        { i: '7', x: 0, y: 9, w: 6, h: 3 },
        { i: '8', x: 0, y: 12, w: 6, h: 3 },
        { i: '9', x: 0, y: 12, w: 6, h: 3 },
        { i: '10', x: 0, y: 15, w: 6, h: 3 },
        { i: '11', x: 0, y: 15, w: 6, h: 3 },
    ]

const CardGrid = (props: any) => {
    const cardStack = useSelector((state: RootState) => state.console.cardStackData)

    const layouts = { lg: layoutLg, md: layoutMd, sm: layoutSm }
    const ResponsiveGridLayout = WidthProvider(Responsive)

    // useEffect(() => {
    //     console.log(`ImbCardStack useEffect cardStack = `, cardStack)
    // }, [cardStack])

    useEffect(() => {
        defaults.global.animation = false
    }, [])

    const children = React.useMemo(() => {
        return cardStack.map((val: any, index: any) => (
            <div key={index}>
                <ImbTickerCard index={index} />
            </div>
        ))
    }, [cardStack])

    // const cards = cardStack.map((val: any, index: any) => (
    //     <div key={index}>
    //         <TickerCard index={index} />
    //     </div>
    // ))

    return (
        <ResponsiveGridLayout measureBeforeMount={true} className='layout' layouts={layouts} cols={{ lg: 12, md: 12, sm: 6 }} breakpoints={{ lg: 1300, md: 1024, sm: 668 }}>
            {children}
        </ResponsiveGridLayout>
    )
}

export default CardGrid
